import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';

const Row = ({
	row, idx, intl, can, remove
}) => (
	<tr
		className={cn({ 'modify-background': Boolean(idx % 2) })}
	>
		<td className='id'>{row.id}</td>
		<td className='title'>{row.title}</td>
		<td className='description'>
			<div className='description-wrapper'>
				<div className='text'>{row.leads_required}</div>
			</div>
		</td>
		<td className='price'>{row.offer_category}</td>
		<td className='actions'>
			{can('edit') && <Link className='edit' to={`/achievements/edit/${row.id}`}/>}
			{can('edit') && <a className='action_delete' onClick={remove.bind(null, row.id)}/>}
		</td>
	</tr>
);

Row.propTypes = {
	row: PropTypes.object,
	intl: PropTypes.func,
	idx: PropTypes.number,
	can: PropTypes.func
};

const Table = ({
	narrow, table, remove, intl, isIndexing, can
}) =>
	<div className='table-container'>
		<table
			className={cn({
				'simple-table goods-table': true,
				narrow
			})}
		>
			<thead className='simple-table__head font-roboto-medium'>
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								[header.index || header.title.toLowerCase()]: true,
								'sort-header': header.direction,
								[header.className]: header.className
							})}
						>{intl(header.title)}</th>
					))}
				</tr>
			</thead>
			<tbody
				className={cn({
					'simple-table__body': true,
					'table-indexing': isIndexing,
					'default-table-indexing': isIndexing
				})}
			>
				{table.rows && table.rows.map((row, idx) => (
					<Row row={row} remove={remove} key={row.id} idx={idx} intl={intl} can={can} />
				))}
			</tbody>
		</table>
	</div>;

Table.propTypes = {
	narrow: PropTypes.bool,
	table: PropTypes.object,
	intl: PropTypes.func,
	isIndexing: PropTypes.bool,
	can: PropTypes.func
};

export default Table;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/components/table/main.js